module.exports = {
	en: 'SKI.json',
	es: 'SKI_ES.json',
	hk: 'SKI_HK.json',
	cmn: 'SKI_CMN.json',
	ko: 'SKI_KO.json',
	ar: 'SKI_AR.json',
	vi: 'SKI_VI.json',
	ht: 'SKI_HT.json'
};
